import React, { useState } from "react";
import { toast } from "react-toastify";
import { useUpdateBloodRequest } from "../../../hooks/useAdminBloodRequests";

const BLOOD_GROUPS = ["A POSITIVE(+)", "A NEGATIVE(-)", "B POSITIVE(+)", "B NEGATIVE(-)", "O POSITIVE(+)", "O NEGATIVE(-)", "AB POSITIVE(+)", "AB NEGATIVE(-)"];
const REQUEST_TYPES = ["Blood", "Platelets", "Plasma"];
const STATUS_OPTIONS = ["open", "fulfilled", "cancelled", "closed"];

const BloodRequestEditModal = ({ request, onClose }) => {
  const [form, setForm] = useState({
    patient: request.patient || "",
    medical: request.medical || "",
    unit: request.unit || "",
    number: request.number || "",
    group: request.group || "",
    date: request.date || "",
    time: request.time || "",
    type: request.type || "",
    district: request.district || "",
    area: request.area || "",
    comment: request.comment || "",
    status: request.status || "open",
  });

  const updateMutation = useUpdateBloodRequest();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateMutation.mutateAsync({ id: request._id, data: form });
      toast.success("Blood request updated successfully");
      onClose();
    } catch (err) {
      toast.error(err.message || "Failed to update request");
    }
  };

  return (
    <div className="modal modal-open">
      <div className="modal-box max-w-2xl">
        <h3 className="font-bold text-lg mb-4">Edit Blood Request</h3>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="form-control">
              <label className="label"><span className="label-text">Patient</span></label>
              <input type="text" name="patient" value={form.patient} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Medical</span></label>
              <input type="text" name="medical" value={form.medical} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Phone</span></label>
              <input type="text" name="number" value={form.number} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Units</span></label>
              <input type="text" name="unit" value={form.unit} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Blood Group</span></label>
              <select name="group" value={form.group} onChange={handleChange} className="select select-bordered select-sm">
                <option value="">Select</option>
                {BLOOD_GROUPS.map((g) => <option key={g} value={g}>{g}</option>)}
              </select>
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Type</span></label>
              <select name="type" value={form.type} onChange={handleChange} className="select select-bordered select-sm">
                <option value="">Select</option>
                {REQUEST_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Date</span></label>
              <input type="date" name="date" value={form.date} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Time</span></label>
              <input type="time" name="time" value={form.time} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">District</span></label>
              <input type="text" name="district" value={form.district} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Area</span></label>
              <input type="text" name="area" value={form.area} onChange={handleChange} className="input input-bordered input-sm" />
            </div>
            <div className="form-control">
              <label className="label"><span className="label-text">Status</span></label>
              <select name="status" value={form.status} onChange={handleChange} className="select select-bordered select-sm">
                {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>)}
              </select>
            </div>
          </div>
          <div className="form-control">
            <label className="label"><span className="label-text">Comment</span></label>
            <textarea name="comment" value={form.comment} onChange={handleChange} className="textarea textarea-bordered textarea-sm" rows="2"></textarea>
          </div>
          <div className="modal-action">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
            <button type="submit" className={`btn btn-primary ${updateMutation.isLoading ? "loading" : ""}`} disabled={updateMutation.isLoading}>
              Save Changes
            </button>
          </div>
        </form>
      </div>
      <div className="modal-backdrop" onClick={onClose}></div>
    </div>
  );
};

export default BloodRequestEditModal;
